import { makeStyles } from '@material-ui/core'
import { EndOnboardingPresenter } from 'components/domain/onboarding/EndOnboardingPresenter'
import { useUser } from 'components/providers/UserProvider'
import Ellipse1 from 'img/Ellipse1.png'
import Ellipse2 from 'img/Ellipse2.png'
import { useOnboardingStore } from 'lib/hooks/useOnboardingStore'
import { useEffect } from 'react'
import { Redirect } from 'react-router-dom'

const useStyles = makeStyles(() => ({
  body: {
    backgroundColor: 'var(--onboarding-bg) !important',
    backgroundImage: `url(${Ellipse1}), url(${Ellipse2})`,
    backgroundPosition: 'top right, bottom left',
    backgroundRepeat: 'no-repeat, no-repeat',
    backgroundSize: '45vw 45vw, 45vw 45vw',
    minHeight: '100vh',
    backgroundAttachment: 'fixed, fixed',
  },
  onboardingWrapper: {
    height: '100vh',
    overflowY: 'auto',
    WebkitOverflowScrolling: 'touch',
    // Firefox
    scrollbarWidth: 'none',
  },
  '.onboarding-wrapper::-webkit-scrollbar': {
    display: 'none', // Chrome/Safari
  },
}))

export const EndOnboarding = (): JSX.Element => {
  const { user } = useUser()
  const classes = useStyles()
  const { visitEndOnboarding } = useOnboardingStore()
  user

  useEffect(() => {
    document.body.classList.add(classes.body)

    return () => {
      document.body.classList.remove(classes.body) // Cleaning when the component unmount
    }
  }, [classes.body])

  if (user.hasOnboarded) {
    return <Redirect to="/" />
  } else if (!visitEndOnboarding) {
    return <Redirect to="/onboarding" />
  } else
    return (
      <div className={classes.onboardingWrapper}>
        <EndOnboardingPresenter />
      </div>
    )
}
